// IndexedDB preserves the selected Files across a reload. Keys are seller-scoped.
function database() {
  return new Promise((resolve, reject) => {
    const request = indexedDB.open('fomo-swap-drafts', 1)
    request.onupgradeneeded = () => request.result.createObjectStore('drafts')
    request.onsuccess = () => resolve(request.result)
    request.onerror = () => reject(request.error)
  })
}
export async function swapDraftStore(key, value, remove = false) {
  const db = await database()
  try {
    return await new Promise((resolve, reject) => {
      const tx = db.transaction('drafts', value === undefined && !remove ? 'readonly' : 'readwrite')
      const store = tx.objectStore('drafts')
      const request = remove ? store.delete(key) : value === undefined ? store.get(key) : store.put(value, key)
      tx.oncomplete = () => resolve(request.result)
      tx.onerror = () => reject(tx.error)
      tx.onabort = () => reject(tx.error)
    })
  } finally { db.close() }
}
